<template>
  <div id="failure">
    <div>
      <img
        class="image"
        src="../assets/Feed_logo.png"
        height="75%" 
        width="75%"
      />
      <h1>Tuvimos un problema</h1>
      <p>
        No pudimos registrar tu pedido. Comunicate con nosotros o acercate al
        mostrador si estás en el local para poder realizar tu pedido
      </p>
      <p>Lamentamos los inconvenientes causados!</p>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    this.$store.commit("RESET_STATE");
  },
  data() {
    return {};
  }
};
</script>
<style scoped>
#failure {
  height: 40em;
  position: relative;
}
.image {
  height: 500;
  width: 500;
  padding-bottom: 10vh;
}
#failure div {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/pages/Failure.vue